import { NavMain } from "@/components/nav-main";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
  // SidebarRail,
} from "@/components/ui/sidebar";
import DynamicInstitutionName from "./common/DynamicInstitutionName";
import { NavLink, useLocation } from "react-router";
import { Button, Icon } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";
import { useAuthorization } from "@/hooks/use-authorization";
import { getMenuData } from "@/utils/menu";
import { UserMenu } from "./site-header";
import { useEffect } from "react";
import Goes from "./common/logos/GOES";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { toggleSidebar, open, isMobile, setOpenMobile } = useSidebar();
  const { hasPermission } = useAuthorization();
  const data = getMenuData(hasPermission);
  const { pathname } = useLocation();

  useEffect(() => {
    if (isMobile && open) {
      setOpenMobile(false);
    }
  }, [pathname, isMobile, open, setOpenMobile]);

  return (
    <Sidebar
      collapsible="icon"
      className="z-11"
      data-testid="app-sidebar"
      {...props}
    >
      <SidebarHeader className="border-b border-neutral-silent">
        <div className="flex items-center justify-between w-full h-15">
          <NavLink
            className={cn(
              "shrink-0 flex items-center justify-between",
              open && "gap-3",
            )}
            to="/"
            aria-label="Inicio"
          >
            <Goes />
            <div
              className={cn(
                open
                  ? "h-8 w-px border-l border-neutral-loud"
                  : "opacity-0 w-0",
              )}
            />
            <DynamicInstitutionName
              className={cn(
                open
                  ? "text-body-loud font-semibold text-sm leading-2xl"
                  : "opacity-0 w-0",
              )}
            />
          </NavLink>
          <Button
            variant="ghost"
            className={cn(
              "size-8",
              !open &&
                "z-50 sidebar-toggle-button translate-x-0.75 border-transparent! bg-neutral-background! after:w-4 after:absolute after:-top-0.5 after:right-0 after:border after:h-8.5 after:rounded-r-md after:border-l-0 after:border-neutral-silent hover:after:border-l hover:after:w-8 hover:after:rounded-md",
            )}
            onClick={() => {
              toggleSidebar();
            }}
          >
            <Icon
              type="far"
              name="chevron-circle-left"
              className={cn(
                "text-body-loud transition-all text-sm leading-2xl",
                !open && "rotate-180",
              )}
            />
            <span className="sr-only" data-testid="toggle-app-side-menu">
              {open ? "Cerrar menú lateral" : "Abrir menú lateral"}
            </span>
          </Button>
        </div>
      </SidebarHeader>
      <SidebarContent className="text-body-loud mt-4 overflow-y-auto">
        {Object.keys(data)
          .filter((key) => {
            return data[key as keyof typeof data];
          })
          .map((key) => {
            const group = data[key as keyof typeof data]!;
            return (
              <NavMain
                key={`sidebar-${group.title}-group`}
                title={group.title}
                items={group.items}
              />
            );
          })}
      </SidebarContent>
      <SidebarFooter className="border-t border-neutral-silent p-3.5 overflow-hidden">
        <UserMenu />
      </SidebarFooter>
      {/* <SidebarRail /> */}
    </Sidebar>
  );
}
